module.exports = __webpack_public_path__ + "img/title_sp.9af62a02.svg";